import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    title: "1. Verantwortliche Stelle",
    body: (
      <>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist
          Grayscale Media. Die vollständigen Kontaktdaten finden Sie im{" "}
          <Link to="/impressum" className="underline underline-offset-2 hover:text-white">
            Impressum
          </Link>
          .
        </p>
      </>
    ),
  },
  {
    title: "2. Allgemeine Hinweise",
    body: (
      <p>
        Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir verarbeiten
        personenbezogene Daten ausschließlich im Rahmen der gesetzlichen
        Bestimmungen (DSGVO, BDSG, TDDDG). Diese Erklärung informiert Sie
        darüber, welche Daten beim Besuch dieser Website erhoben werden und
        wofür sie verwendet werden.
      </p>
    ),
  },
  {
    title: "3. Hosting",
    body: (
      <p>
        Diese Website wird bei einem Hosting-Dienstleister mit Serverstandort
        in Deutschland betrieben. Bei jedem Aufruf werden technische Daten
        (z. B. IP-Adresse, User-Agent, Zeitpunkt der Anfrage) verarbeitet, die
        für die sichere Auslieferung der Website erforderlich sind
        (Art. 6 Abs. 1 lit. f DSGVO).
      </p>
    ),
  },
  {
    title: "4. Server-Logfiles",
    body: (
      <p>
        Der Provider erhebt und speichert automatisch Informationen in
        Server-Logfiles, die Ihr Browser an uns übermittelt: Browsertyp und
        -version, verwendetes Betriebssystem, Referrer URL, Hostname des
        zugreifenden Rechners, Uhrzeit der Serveranfrage und IP-Adresse. Eine
        Zusammenführung dieser Daten mit anderen Datenquellen findet nicht
        statt. Die Daten werden zur Sicherstellung des reibungslosen Betriebs
        verarbeitet und nach kurzer Zeit gelöscht.
      </p>
    ),
  },
  {
    title: "5. Kontaktformular",
    body: (
      <p>
        Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen,
        werden Ihre Angaben (Name, E-Mail-Adresse, optional Budget,
        Nachricht) zur Bearbeitung Ihrer Anfrage gespeichert. Rechtsgrundlage
        ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines Vertragsverhältnisses)
        bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
        Bearbeitung von Anfragen). Diese Daten geben wir nicht an Dritte
        weiter.
      </p>
    ),
  },
  {
    title: "6. Speicherdauer",
    body: (
      <p>
        Wir speichern personenbezogene Daten nur so lange, wie es für den
        jeweiligen Zweck erforderlich ist oder gesetzliche
        Aufbewahrungsfristen es vorsehen. Anfragen, die zu keiner
        Geschäftsbeziehung führen, löschen wir spätestens nach sechs Monaten.
      </p>
    ),
  },
  {
    title: "7. Cookies",
    body: (
      <p>
        Diese Website verwendet ausschließlich technisch notwendige Cookies,
        die für den Betrieb der Seite erforderlich sind. Es findet kein
        Tracking durch Dritte statt. Es werden keine Marketing- oder
        Analyse-Cookies eingesetzt, die einer Einwilligung bedürfen.
      </p>
    ),
  },
  {
    title: "8. Ihre Rechte",
    body: (
      <p>
        Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO),
        Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der
        Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie ein
        Widerspruchsrecht (Art. 21). Bitte wenden Sie sich dazu an die
        verantwortliche Stelle.
      </p>
    ),
  },
  {
    title: "9. Beschwerderecht",
    body: (
      <p>
        Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
        beschweren – etwa beim Thüringer Landesbeauftragten für den
        Datenschutz und die Informationsfreiheit.
      </p>
    ),
  },
  {
    title: "10. Aktualität dieser Erklärung",
    body: (
      <p>
        Diese Datenschutzerklärung wird bei Änderungen der Rechtslage oder
        unserer Prozesse angepasst. Es gilt die jeweils aktuelle, hier
        veröffentlichte Fassung.
      </p>
    ),
  },
];

export default function Datenschutz() {
  return (
    <main data-testid="datenschutz-page" className="min-h-screen bg-[#050505] text-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="mt-8 font-display text-4xl sm:text-5xl tracking-tight">
          Datenschutz
        </h1>
        <p className="mt-3 text-sm text-zinc-500">
          Informationen zur Verarbeitung personenbezogener Daten gemäß
          Art. 13 DSGVO.
        </p>

        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <section key={s.title} className="space-y-3 text-zinc-400 text-sm leading-relaxed">
              <h2 className="font-display text-lg text-white tracking-tight">
                {s.title}
              </h2>
              {s.body}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
